export const INVOICE_FILE_TYPES = [
  'original_pdf',
  'processed_pdf',
  'original_xml',
  'email',
] as const;
